import { signal } from '@codegrade/utils';
/** Emitted after a user has been logged out. */
export const AFTER_USER_CHANGED = new signal.Signal('AFTER_USER_CHANGED', {
    sequential: true,
});
/** Emitted when the store is created. */
export const STORE_CREATED = new signal.Signal('STORE_CREATED', {
    sticky: true,
});
